import { ChevronDown } from 'lucide-react';

export const HeroScrollButton = () => (
  <button data-testid="hero-scroll-button" type="button" onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })} className="absolute left-1/2 -translate-x-1/2 bottom-8 z-10 flex flex-col items-center gap-3 text-white/55 hover:text-white transition group">
    <span className="text-[10px] tracking-[0.3em]">ASAGI KAYDIR</span>
    <span className="w-[22px] h-[36px] border border-white/30 rounded-full flex justify-center pt-2 group-hover:border-accent transition-colors"><span className="w-1 h-1 rounded-full bg-accent scroll-dot" /></span>
    <ChevronDown size={16} className="opacity-50 group-hover:translate-y-1 group-hover:opacity-100 transition-all" />
  </button>
);